
module.exports =  {
  TITLE: {
    default: '搜索酒店|亚洲数万家酒店在线预订',
    detail: '|百高酒店预订',
  },
  hotel: {
    // 酒店搜索改版新增翻译--中文
    ROOMS: '客房数',
    GUESTS: '住客数',
    CHECK_IN_NUM: '入住人数',
    PREFIX_ADULTS: '',
    SUFFIX_ADULT: '成人',
    SUFFIX_ADULTS: '成人',
    PREFIX_CHILDREN: '',
    SUFFIX_CHILD: '儿童',
    SUFFIX_CHILDREN: '儿童',
    CHILD_AGE: '儿童年龄',
    NO_MATCH_TIPS: '以下客房不符合“间数”、“人数”筛选条件',

    Book_Hotel: '酒店预订',
    Select_your_destination: '请选择目的地',
    Please_enter_your_destination: '请输入目的地/酒店',
    Booked_up: '已订完',
    Hotel_description: '酒店介绍',
    Check_in_date: '入住日期',
    Check_out_date: '退房日期',
    Sold_out: '售完',
    Non_refundable: '不可取消',
    reserve: '订',
    Pay_Online: '在线付',
    Only_rooms_left_before: '仅剩',
    Only_rooms_left_after: '间',
    Cancellation_Policy: '取消政策',
    See_all_prices_before: '查看全部',
    See_all_prices_after: '个价格',
    Estimated_time_of_arrival: '预计到店',
    make_your_schedule_well_planned: '为当地时间，选定后请合理安排出行。',
    Hotel_Not_Found: '未找到所选条件的酒店',
    Please_change_your_search: '请修改条件重新查询',
    Submit_an_application: '提交申请',
    Hotel_Confirmation: '酒店确认',
    Many_Night_Stay_before: '入住',
    Many_Night_Stay_after: '晚',
    Hotel_Booking_Number: '酒店预约号',
    Online_Payment: '在线支付',
    The_guest_Room_before: '入住人(房间',
    The_guest_Room_after: ')',
    Contact_number: '联系号码',
    Bring_all_valid_IDs: '入住时请携带所有入住人的有效身份证件。',
    Hotels_Found_before: '搜索到',
    Hotels_Found_after: '家酒店',
    Hotels_Presented_before: '当前显示',
    Hotels_Presented_center: '家酒店(共',
    Hotels_Presented_after: '家)',
    Please_change_the_dates: '没有查询到所选日期的房型，请重新选择住宿日期。',
    Login: '预订酒店需要登录app',
    Nights_in_total_before: '共',
    Nights_in_total_after: '晚',
    Location: '酒店位置',
    Pictures: '酒店图片',
    Description: '酒店介绍',
    Policy: '酒店政策',
    Check_in_and_check_out_time: '入离时间',
    Check_in_and_Check_out_before: '入住时间：',
    Check_in_and_Check_out_center: '以后  离店时间：',
    Check_in_and_Check_out_after: '以前',
    Check_in_time: '入住时间',
    Check_out_time: '离店时间',
    Facility_Service: '设施服务',
    Payment_methods: '酒店接受的支付方式',
    Hotel_Address: '酒店地址',
    Pay_online: '在线支付',
    Pay_offline: '线下支付',
    Night_stay_before: '入住',
    Night_stay_after: '晚,',
    Rooms_total_before: '间共',
    Rooms_total_after: '',
    Guest_name_must_be_provided: '入住人姓名必须填写完整',
    Please_fill_in_your_contact_number: '请输入联系号码',
    Select_estimated_time_of_arrival: '请选择预计到店时间',
    Number_of_Rooms: '房间数量',
    Maximum_guests_per_room_before: '每间最多入住',
    Maximum_guests_per_room_after: '人',
    Many_Rooms: '间',
    Service_Fee_Included: '(含税和服务费)',
    Last_Name: '姓氏拼音',
    First_Name: '名字拼音',
    Room: '房间',
    Additional_Tax: '另付税费',
    Please_inform_the_hotel: '若超过登记的预计到店时间，请务必联络住宿酒店。',
    Please_inform_the_hotel_first: '没有提前与酒店联络，导致超过最迟入住时间时，房间或晚餐安排会有影响，请注意提前确认。',
    Booking_Cancellation: '取消订单',
    Reason_of_Cancellation: '取消原因',
    Incorrect_Information_Filled: '信息填错',
    Itinerary_Changed: '行程改变',
    Lower_price_on_other_APP: '其他APP更便宜',
    Low_quality_hotel: '酒店质量差',
    Book_at_a_lower_price: '前台预订更实惠',
    Other: '其他',
    Please_write_your_reason: '请填写原因',
    After_cancellation_done: '取消成功后，款项将会在3个工作日退回到您的原支付方。',
    How_to_fill_in_the_guest_name: '入住人填写说明',
    It_should_be_exactly_the_same: '预订酒店必须填写入住人的姓名，以英文字母填写。需与入住时所持证件完全一致。',
    How_to_fill_in_a_Chinese_name: '中文姓名填写方法：',
    How_to_fill_in_a_English_name: '英文姓名填写方法：',
    For_example: '例如：“韩梅梅”，姓填写“Han”，名填写“Meimei”',
    No_specical_characters: '① 英文姓名中不能包含数字或特殊符号',
    Name_rule_first: '② 姓在前，名在后，如有中间名则空一格紧随名之后。',
    Name_rule_second: ' 例如：Green / Jim Stephanie',
    Details: '明细',
    Pay_now: '立即支付',
    Hotel: '酒店',
    Check_in: '入住：',
    Car: '租车',
    All_bookings: '全部订单',
    All: '全部',
    PROMPT: '提示',

    Search: '搜索',
    COST_DESCRIPTION: '费用明细',
    TOTAL: '合计',
    SEE_ORDER_INFO_TO: '支付',
    KONW: '知道了',
    BOOKING_INFORMATION: '预订须知',
    Book_Now: '立即支付',
    MAP: '地图',
    CONTACT_INFORMATION: '联系方式',
    LOADING: '加载中...',
    SORT_FILTER: '排序/筛选',
    SCREENING: '筛选',
    SEQUENCE: '排序',
    PHONE_ASK: '电话咨询',
    ABOVE: '起',
    SUBMINT_ORDER: '提交订单',
    OK: '确定',
    Order_detail: '订单明细',
    BOOKING_INFO: '订单信息',
    PAYMENT_AMOUNT: '订单金额',
    Order_time: '下单时间',
    ORDER_NUMBERS: '订单号',
    PAY_TYPE: '支付方式',
    BALANCE: '账户余额',
    CURRENT_BALANCE_BEGIN: '当前余额',
    OVERPLUS_BALANCE_BEGIN: '结余',
    OTHER_PAYMENT: '当前余额',
    Unionpay: '银联支付',
    Wechatpay: '微信支付',
    Alipay: '支付宝支付',
    AGREE_SERVICE_AGREEMENT_BEFORE: '点击“立即支付”即表示您同意百高',
    AGREE_SERVICE_AGREEMENT_AFTER: '',
    SERVICE_AGREEMENT: '《服务协议》',
    PAYMENT_ORDER: '支付订单',
    Total_pay: '应付总额',
    PAY_SUCCESS: '支付成功',
    CHECK_THE_ORDER: '查看订单',
    BACK_TO_INDEX: '返回首页',
    CANCEL: '取消',
    RECOMMED: '百高推荐',
    PRICE: '价格',
    HIGH: '高',
    LOW: '低',
    RESET: '重置',
    SELECT_TIME: '选择日期',
    Hotel_guest: '入住人',
    Select: '请选择',
    Emial_address: '请输入邮箱地址',
    Booking_explan: '预订说明',
    VIEW_MORE: '查看更多',
    COLLAPSE: '收起',
    Week: '周',
    Month: '月',
    TOURISM_CHECK_IN_HOTEL: '入住',
    TOURISM_LEAVE_HOTEL: '离店',
    arrive: '目的地',
    Room_description: '客房说明',
    Meals: '餐饮',
    Room_Type: '房型',
    BOOKING_EXPLANATION: '预订说明',
    BOOKING_BUTTON: '预订',
    REMIND_SUBMIT_ORDER: '继续预订',
    login_now: '提交酒店订单需要登录，立即登录？',
    the_real_scene: '图片仅供参考，请以实际入住酒店为准',
    Bed: '床型',
    Rooms: '房型信息',
    Room_rate: '房费情况',
    notified_by_SMS: '预订成功后，会向您发送短信通知',
    email_notifications: '用于接收邮件通知',
    Booking_deadline: '截止预订时间',
    Child: '儿童',
    Additional_notes_about_payment: '额外费用',
    Nights: '入住天数',
    Minimum_nights_before: '至少',
    Minimum_nights_after: '天',
    Size: '面积',
    Guests: '人数',
    Room_rate_1: '房费',
    Tax_service_fee: '税和服务费',
    Pay_now_1: '去支付',
    Filter: '筛选条件',
    Room_rate2: '费用',
    Show_on_map: '查看地图',
    Detail: '查看详情',
    Room_Detail: '查看房间詳情',

    TAXES_INCL: '含税总价',
    SEARCH_EMPTY_TIP: '抱歉，此酒店在所选日期内我们没有空房了，您可以： ' +
      '搜索其他日期  或者  搜索其他酒店住宿',
    severalNight: '晚',
    immediateBooking: '立即预订',
    Refundable: '条件取消',
    MORE: '更多',
    adultsCompany: '名大人',
    ServiceTerms: '入住条款',
    roomPlan: '方案',
    guestRoom: '客房',
    searchAgain: '重新搜索',
    roomNight: '间/夜',

    NAME_TXT: '姓名',
    HOLDER_NAME: '持卡人姓名',
    EXPIRATION_DATE: '到期日',
    FORMAT_TXT: '格式',
    SECURITY_CODE: '安全码',
    MASTER_CARD_NAME: '万事达卡',
    JCB_CARD_NAME: '日财卡',
    DIGITS_ON_BACK_OF_CARD: '卡片背后的3位数字。',
    AMERICAN_EXPRESS_NAME: '美国运通',
    FOUR_CAR_NUM_TIPS: '卡片正面的4位数',
    ENTER_COMPLETE_CARD_NUM: '请输入完整卡号',
    PLEASE_ENTER_HOLDER_NAME: '请输入持卡人姓名',
    ENTER_SECURITY_CODE: '请输入安全码',
    ENTER_EXPIRATION_DATE: '请输入到期日',
    ROOM_DETAILS: '客房详情',
    CONDITION_CANCEL: '条件取消',
    CHOOSE_PAYMENT_METHOD: '选择支付方式',
    ORDER_TOTAL_LUMP: '订单总额',
    CREDIT_CARD_NUM: '借记卡/信用卡号',
    MAINLAND_CARD_ONLY: '仅限中国大陆以外地区发行的银行卡',
    SHUT_DOWN: '关闭',
    PROVIDER_FROM_CHINA_BANK: '由中国银行提供支付服务',

    COUPON: '优惠券',
    APPLY_A_COUPON: '优惠券兑换',
    NO_USE: '所结算商品不可使用',
    Discard: '放弃',
    REDEEM: '兑换',
    EMPTY_COUPON: '请输入优惠码',
    NOTICE_COUPON: '每次只可以使用一张优惠券；提交订单后，该优惠券将被认为已经使用。',

    BREAKFAST_INCLUDE: '含餐',
    BREAKFAST_EXCLUDE: '不含餐',
    DOUBLE_BED: '大床',
    TWIN_BED: '双床',
    FREE_CANCEL: '免费取消',
    MEALS: '餐食',
    EVALUATION: '评价',
    FEATURED_REVIEWS: '评价精选',
    ALL_REVIEWS: '全部评价',
    OVERALL_EVALUATION: '总体评价',
    ANONYMOUS: '匿名',
    EVAL_GENERAL_LIST_1: '差',
    EVAL_GENERAL_LIST_2: '不好',
    EVAL_GENERAL_LIST_3: '一般',
    EVAL_GENERAL_LIST_4: '好',
    EVAL_GENERAL_LIST_5: '很好',
    MAX_IMAGES_WITH_NINE: '最多只能选择9张图片!',
    GRADE_EVAL: '请选择总体评价',
    DISTANCE_FILTER: '距离 近→远',
    EDIT_EVALUATION: '写评价',
    GO_TO_EVAL: '去评价',
    EVAL_POINTS_AWARD: '最高可获1000积分(可抵扣10RMB)',
    NEARBY_LIKE_HOTEL: '附近相似酒店',
    DISTANCE_HOTEL: '距离酒店',
    PLEASE_ENTER_COMMENT: '请输入评论内容',
    AWARD_POINTS_TIPS: '评论有机会赢<span>1000积分</span>(可抵扣10RMB)',
    NO_SHOW_ANONYMOUS_AVATAR: '匿名评价不会展示您的头像和昵称',
    LOCATION: '位置',
    FACILITY: '设施',
    SERVICE: '服务',
    HEALTH: '卫生',
    LANGUAGE_SELECT: '语言选择',
    LIMIT_COMMENT_TXT: '评价字数必须在 5~2000 内',
    EVAL_NUM_AFTER: '条评价',
    HOTEL_STR: '详情',
    SUBMIT_EVAL: '提交',
    SETTLEMENT_FEEL: '入住感受',
    SHARE_MEDIA: '分享视频/图片',
  },
  header: {
    SKIING: '滑雪',
    header_internal_call: '中国大陆：',
    header_abroad_call: '海外：',
    header_app_download: '手机版',
    service_telephone: '客服电话',
    account_number: '账号',
    if_bg_user: '还不是百高会员？',
    home: '首页',
    hotel: '酒店',
    Golf: '高尔夫',
    PLAY_STAY: '球+酒',
    RENT_CAR_HOME: '租车',
    center_user: '会员中心',
    header_my_order: '我的订单',
    header_notmember_order: '非会员订单',
    header_edit_password: '修改密码',
    header_logout: '退出登录',
    header_login: '登录',
    header_register: '注册',
    header_point: '我的积分',
    header_all_language: '所有语言',
    down_load_app: '扫描二维码下载',
    login_discount_tip: '登录获得积分和其它独家优惠'
  },
  footer: {
    footer_partner: '合作伙伴',
    footer_about_us: '关于我们',
    footer_about_baigolf: '关于BaiGolf.com',
    footer_privacy_policy: 'BaiGolf.com隐私政策',
    footer_use_of_terms: 'BaiGolf.com服务条款',
    footer_contact_us: '联系我们',
    footer_sitemap: '站点地图',
    footer_use_of_question: '常见问题',
    footer_ios_system: 'iOS系统',
    footer_android_system: '安卓系统',
    footer_app_load: 'APP下载',
    footer_sina_weibo: '新浪微博',
    footer_tencent_weibo: '腾讯微博',
    footer_share_to: '分享至',
    copyright1: '广州市百高美燚信息技术有限公司 版权所有',
    copyright2: '粤ICP备14070002号',
    baigolf_question: '常见问题',
    news_center: '新闻中心',
    about_baigolf: '关于BaiGolf',
    help: '帮助',
    management_system: '球会管理系统',
    wechat_official_account: '关注微信公众号',
    download_baiGolf_app: '扫码免费下载App',
    privacy_policy: '隐私政策',
    use_of_terms: '服务条款',
    footer_integral: '积分政策',
    footer_reserve: '预订政策',
    footer_abroad_call: '海外',
    footer_internal_call: '中国大陆'
  }
}



// WEBPACK FOOTER //
// ./src/lang/zh_cn.js